<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ChTitle" id="ch2"><a id="page_9"></a><a href="#/Contents#rch2">If I Was President (“Were” May Be Substituted by Those Who Prefer It)</a></h2>
<p class="noindentp"><span><span>If I was President</span></span></p>
<p class="noindentp"><span><span>The first thing I would do</span></span></p>
<p class="noindentp"><span><span>is call Mumia Abu-Jamal.</span></span></p>
<p class="noindentp"><span><span>No,</span></span></p>
<p class="noindentp"><span><span>if I was President</span></span></p>
<p class="noindentp"><span><span>the first thing I would do</span></span></p>
<p class="noindentp"><span><span>is call Leonard Peltier.</span></span></p>
<p class="noindentp"><span><span>No,</span></span></p>
<p class="noindentp"><span><span>if I was President</span></span></p>
<p class="noindentp"><span><span>the first person I would call</span></span></p>
<p class="noindentp"><span><span>is that rascal</span></span></p>
<p class="noindentp"><span><span>John Trudell.</span></span></p>
<p class="noindentp"><span><span>No,</span></span></p>
<p class="noindentp"><span><span>the first person I’d call</span></span></p>
<p class="noindentp"><span><span>is that other rascal</span></span></p>
<p class="noindentp"><span><span>Dennis Banks.</span></span></p>
<p class="noindentp1"><span><span>I would also call</span></span></p>
<p class="noindentp"><span><span>Alice Walker.</span></span></p>
<p class="noindentp1"><span><span>I would make a conference call.</span></span></p>
<p class="noindentp"><span><span><a id="page_10"></a>And I would say this:</span></span></p>
<p class="noindentp1"><span><span>Yo, you troublemakers,</span></span></p>
<p class="noindentp"><span><span>it is time to let all of us</span></span></p>
<p class="noindentp"><span><span>out of prison.</span></span></p>
<p class="noindentp"><span><span>Pack up your things.</span></span></p>
<p class="noindentp1"><span><span>Dennis and John,</span></span></p>
<p class="noindentp"><span><span>collect Alice Walker</span></span></p>
<p class="noindentp"><span><span>if you can find her:</span></span></p>
<p class="noindentp"><span><span>in Mendocino, Molokai, Mexico or</span></span></p>
<p class="noindentp"><span><span>Gaza,</span></span></p>
<p class="noindentp"><span><span>&amp; head out to the prisons</span></span></p>
<p class="noindentp"><span><span>where Mumia and Leonard</span></span></p>
<p class="noindentp"><span><span>are waiting for you.</span></span></p>
<p class="noindentp"><span><span>They will be traveling</span></span></p>
<p class="noindentp"><span><span>light.</span></span></p>
<p class="noindentp"><span><span>Mumia used to own a lot</span></span></p>
<p class="noindentp"><span><span>of papers</span></span></p>
<p class="noindentp"><span><span>but they took most of those</span></span></p>
<p class="noindentp"><span><span>away from him.</span></span></p>
<p class="noindentp"><span><span>Leonard</span></span></p>
<p class="noindentp"><span><span>will probably want to drag along</span></span></p>
<p class="noindentp"><span><span>some of his</span></span></p>
<p class="noindentp"><span><span>canvases.</span></span></p>
<p class="noindentp1"><span><span><a id="page_11"></a>Alice</span></span></p>
<p class="noindentp"><span><span>who may well be</span></span></p>
<p class="noindentp"><span><span>shopping</span></span></p>
<p class="noindentp"><span><span>in New Delhi</span></span></p>
<p class="noindentp"><span><span>will no doubt want to</span></span></p>
<p class="noindentp"><span><span>dress up for the occasion</span></span></p>
<p class="noindentp"><span><span>in a sparkly shalwar kemeez.</span></span></p>
<p class="noindentp1"><span><span>My next call is going to be</span></span></p>
<p class="noindentp"><span><span>to the Cubans</span></span></p>
<p class="noindentp"><span><span>all five of them;</span></span></p>
<p class="noindentp"><span><span>so stop worrying.</span></span></p>
<p class="noindentp"><span><span>For now, you’re my fish.</span></span></p>
<p class="noindentp"><span><span>I just had this long letter</span></span></p>
<p class="noindentp"><span><span>from Alice and she has begged me</span></span></p>
<p class="noindentp"><span><span>to put an end</span></span></p>
<p class="noindentp"><span><span>to her suffering.</span></span></p>
<p class="noindentp1"><span><span>What? she said.</span></span></p>
<p class="noindentph"><span><span>You think these men are the only ones who suffer</span></span></p>
<p class="noindentp"><span><span>when Old Style America locks them up</span></span></p>
<p class="noindentp"><span><span>&amp; throws away</span></span></p>
<p class="noindentp"><span><span>the key?</span></span></p>
<p class="noindentp"><span><span>I can’t tell you, she goes on,</span></span></p>
<p class="noindentp"><span><span><a id="page_12"></a>the changes</span></span></p>
<p class="noindentp"><span><span>this viciousness</span></span></p>
<p class="noindentp"><span><span>has put me through,</span></span></p>
<p class="noindentp"><span><span>and I have had a child to raise</span></span></p>
<p class="noindentp"><span><span>&amp; classes to teach</span></span></p>
<p class="noindentp"><span><span>&amp; food to buy</span></span></p>
<p class="noindentp"><span><span>and just because</span></span></p>
<p class="noindentp"><span><span>I’m a poet</span></span></p>
<p class="noindentp"><span><span>it doesn’t mean</span></span></p>
<p class="noindentp"><span><span>I don’t have to</span></span></p>
<p class="noindentp"><span><span>pay the mortgage</span></span></p>
<p class="noindentp"><span><span>or the rent.</span></span></p>
<p class="noindentp1"><span><span>Yet all these years,</span></span></p>
<p class="noindentp"><span><span>nearly thirty or something</span></span></p>
<p class="noindentp"><span><span>of them</span></span></p>
<p class="noindentp"><span><span>I have been running around</span></span></p>
<p class="noindentp"><span><span>the country</span></span></p>
<p class="noindentp"><span><span>and the world</span></span></p>
<p class="noindentp"><span><span>trying to arouse justice</span></span></p>
<p class="noindentp"><span><span>for these men.</span></span></p>
<p class="noindentp"><span><span>Tonsillitis</span></span></p>
<p class="noindentp"><span><span>hasn’t stopped me.</span></span></p>
<p class="noindentp"><span><span>Migraine</span></span></p>
<p class="noindentp"><span><span>hasn’t stopped me.</span></span></p>
<p class="noindentp1"><span><span><a id="page_13"></a>Lyme disease</span></span></p>
<p class="noindentp"><span><span>hasn’t stopped me.</span></span></p>
<p class="noindentp"><span><span>And why?</span></span></p>
<p class="noindentp"><span><span>Because</span></span></p>
<p class="noindentp"><span><span>knowing the country</span></span></p>
<p class="noindentp"><span><span>that I’m in,</span></span></p>
<p class="noindentp"><span><span>as you are destined to learn</span></span></p>
<p class="noindentp"><span><span>it too,</span></span></p>
<p class="noindentp"><span><span>I know wrong</span></span></p>
<p class="noindentp"><span><span>when I see it.</span></span></p>
<p class="noindentp"><span><span>If that chair you’re sitting in</span></span></p>
<p class="noindentp"><span><span>could speak</span></span></p>
<p class="noindentp"><span><span>you would have it moved</span></span></p>
<p class="noindentp"><span><span>to another room.</span></span></p>
<p class="noindentp"><span><span>You would burn it.</span></span></p>
<p class="noindentp1"><span><span>So, amigos,</span></span></p>
<p class="noindentp"><span><span>pack your things.</span></span></p>
<p class="noindentp"><span><span>Alice and John and Dennis</span></span></p>
<p class="noindentp"><span><span>are on their way.</span></span></p>
<p class="noindentph"><span><span>They are bringing prayers from Nilak Butler and Bill Wahpepah;</span></span></p>
<p class="noindentp"><span><span>they are bringing sweet grass and white sage</span></span></p>
<p class="noindentp"><span><span>from Pine Ridge.</span></span></p>
<p class="noindentp1"><span><span><a id="page_14"></a>I am the President</span></span></p>
<p class="noindentp"><span><span>at least until the Corporations</span></span></p>
<p class="noindentp"><span><span>purchase the next election,</span></span></p>
<p class="noindentp"><span><span>and this is what I choose</span></span></p>
<p class="noindentp"><span><span>to do on my first day.<sup><span href="#/Backmatter001#en2" id="ren2" title="Link target outside of Sample">2</span></sup></span></span></p>
<p class="centers"><span><span>*<span class="spaces"></span>*<span class="spaces"></span>*</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter002.vue?085ff9a7